import { render, staticRenderFns } from "./PositionStatus.vue?vue&type=template&id=51049081"
import script from "./PositionStatus.vue?vue&type=script&lang=js"
export * from "./PositionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports